import React, { useState, useEffect } from "react";
import Header from "../../components/Header";
import "../../assets/Css/contact.css";
import "../../assets/Css/Style.css";
import Footer from "../../components/Footer";
import { EasyBefore } from "../../constant/Index";
import { useForm } from "../../hooks/Form";
import { ToastMessage } from "../../utils/ShowToastMessage";
import { useDispatch, useSelector } from "react-redux";
import { useUserContactMutation } from "../../store/services/UserContactServices";
import { setSuccess, clearMessage } from "../../store/reducers/globalReducers";

const ContactUs = () => {
	const [errors, setErrors] = useState([]);
	const { state, onChange } = useForm({
		first_name: "",
		last_name: "",
		email: "",
		phone: "",
		query: "",
	});
	let { success } = useSelector((state) => state.globalReducer);
	const [userContact, response] = useUserContactMutation();
	const dispatch = useDispatch();

	const onSubmit = (e) => {
		e.preventDefault();
		const FormDatas = new FormData();
		FormDatas.append("first_name", state.first_name);
		FormDatas.append("last_name", state.last_name);
		FormDatas.append("email", state.email);
		FormDatas.append("phone", state.phone);
		FormDatas.append("query", state.query);
		userContact(FormDatas);
		state.first_name = "";
		state.last_name = "";
		state.email = "";
		state.phone = "";
		state.query = "";
	};

	useEffect(() => {
		if (success !== "") {
			ToastMessage(
				success === "data received successfully"
					? "Contact-us Form Submit Successfully"
					: success,
			);
		}
		return () => {
			dispatch(clearMessage());
		};
	}, [success]);

	useEffect(() => {
		if (response.isError) {
			setErrors(response?.error?.data?.errors);
		}
	}, [response?.error?.data]);

	useEffect(() => {
		if (response.isSuccess) {
			setErrors([]);
			dispatch(setSuccess(response?.data?.message));
		}
	}, [response.isSuccess]);

	return (
		<>
			<section className="contactus_page">
				<div className="right-before">
					<figure>
						<img src={EasyBefore} alt="" className="img-fluid" />
					</figure>
				</div>
				{/* Header */}
				<Header />
				{/* Header */}
				<section className="breadcrums_sec">
					<div className="container">
						<ul>
							<li>Home</li>
							<li>
								<i className="fa fa-angle-right"></i>
							</li>
							<li>Contact Us</li>
						</ul>
					</div>
				</section>
				<section className="contactus_head">
					<div className="container">
						<div className="row">
							<div className="col-md-2"></div>
							<div className="col-md-8">
								<h2 className="text-center">
									<span className="colored">Contact </span>Us
								</h2>
								<p className="text-center">
									Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
									do eiusmod tempor incididunt ut labore et dolore magna aliqua.
									Ut enim ad minim veniam, quis nostrud exercitation ullamco
									Laboris consequat.
								</p>
							</div>
							<div className="col-md-2"></div>
						</div>
					</div>
				</section>
				<section className="contact_form_sec">
					<div className="container">
						<div className="row">
							<div className="col-md-2"></div>
							<div className="col-md-8">
								<div className="form_start">
									<form onSubmit={onSubmit}>
										<div className="row">
											<div className="col-md-6">
												<div className="form-group">
													<input
														type="text"
														className={`${
															errors && errors?.first_name
																? "SetErrorshow form-control"
																: "form-control"
														}`}
														id="inputname"
														placeholder="First Name"
														name="first_name"
														value={state.first_name}
														onChange={onChange}
													/>
												</div>
												{errors && errors?.first_name && (
													<span className="errorMessage">
														<p>{errors && errors?.first_name}</p>
													</span>
												)}
											</div>
											<div className="col-md-6">
												<div className="form-group">
													<input
														type="text"
														className={`${
															errors && errors?.last_name
																? "SetErrorshow form-control"
																: "form-control"
														}`}
														id="inputlname"
														placeholder="Last Name"
														name="last_name"
														value={state.last_name}
														onChange={onChange}
													/>
												</div>
												{errors && errors?.last_name && (
													<span className="errorMessage">
														<p>{errors && errors?.last_name}</p>
													</span>
												)}
											</div>
											<div className="col-md-6">
												<div className="form-group">
													<input
														type="email"
														name="email"
														value={state.email}
														onChange={onChange}
														className={`${
															errors && errors?.email
																? "SetErrorshow form-control"
																: "form-control"
														}`}
														id="inputEmail"
														placeholder="Email Address"
													/>
												</div>
												{errors && errors?.email && (
													<span className="errorMessage">
														<p>{errors && errors?.email}</p>
													</span>
												)}
											</div>
											<div className="col-md-6">
												<div className="form-group">
													<input
														type="tel"
														className={`${
															errors && errors?.phone
																? "SetErrorshow form-control"
																: "form-control"
														}`}
														id="inputpassword"
														placeholder="Phone Number"
														name="phone"
														value={state.phone}
														onChange={onChange}
													/>
												</div>
												{errors && errors?.phone && (
													<span className="errorMessage">
														<p>{errors && errors?.phone}</p>
													</span>
												)}
											</div>
											<div className="col-md-12">
												<div className="form-group">
													<textarea
														className={`${
															errors && errors?.query
																? "SetErrorshow form-control"
																: "form-control"
														}`}
														id="exampleFormControlTextarea1"
														placeholder="Message"
														rows="3"
														name="query"
														value={state.query}
														onChange={onChange}
													></textarea>
												</div>
												{errors && errors?.query && (
													<span className="errorMessage">
														<p>{errors && errors?.query}</p>
													</span>
												)}
											</div>
											<div className="col-md-12">
												<div className="button-group">
													<button className="btn" type="submit">
														Submit
													</button>
												</div>
											</div>
										</div>
									</form>
								</div>
							</div>
							<div className="col-md-2"></div>
						</div>
					</div>
				</section>
				{/* section contact description start here */}
				<section className="contact_desc_sec">
					<div className="container">
						<div className="row">
							<div className="col-md-4 pb-4 pb-lg-0">
								<div className="contact_desc">
									<div className="contact_img">
										<i className="fa fa-envelope"></i>
									</div>
									<div className="contact_head">
										<h4>Email us</h4>
									</div>
									<div className="contact_para">
										<p>
											Email us for general queries, including marketing and
											partnership opportunities.
										</p>
									</div>
									<div className="contact_mail">
										<a href="mailto:info@flit.co.uk">info@flit.co.uk</a>
									</div>
								</div>
							</div>
							<div className="col-md-4 pb-4 pb-lg-0">
								<div className="contact_desc">
									<div className="contact_img">
										<i className="fa fa-phone"></i>
									</div>
									<div className="contact_head">
										<h4>Call us</h4>
									</div>
									<div className="contact_para">
										<p>
											Call us to speak to a member of our team. We are always
											happy to help.
										</p>
									</div>

									<div className="contact_mail">
										<a href="callto:012-3456-7890">012-3456-7890</a>
									</div>
								</div>
							</div>
							<div className="col-md-4">
								<div className="contact_desc">
									<div className="contact_img">
										<i className="fa fa-map-marker"></i>
									</div>
									<div className="contact_head">
										<h4>Our Head Office</h4>
									</div>
									<div className="contact_para">
										<p>
											8182 Fulton Rd. Amirican Plain, <br />
											MA 02130
										</p>
									</div>
									<div className="contact_mail">
										<a href="">Support Center</a>
									</div>
								</div>
							</div>
						</div>
					</div>
				</section>
				{/* section contact description end here */}
				{/* Footer */}
				<Footer />
				{/* Footer */}
			</section>
		</>
	);
};

export default ContactUs;
